import React from "react";
import Scan from "../components/scan";

const Home = () => {
  return (
    <div className="flex flex-col flex-1 max-h-full rounded-md container mx-auto">
      <div className="p-4 text-white bg-blue-500">
        <div className="flex items-center justify-center">
          <span className="text-3xl font-semibold tracking-wider uppercase">Asset Tracking</span>
        </div>
      </div>
      {/* {mode === null && <p className="pt-4 text-center">Select type of code</p>}
      <div className="pt-4 flex flex-col space-y-4 sm:flex-row sm:space-y-0">
        <button
          className={`sizelink colorLink textLink blueBtn ${setColorBarcodeMenu.hover} ${
            mode === "Barcode" ? setColorBarcodeMenu.active : "text-blue-600"
          }`}
          onClick={() => setMode("Barcode")}
        >
          Barcode
        </button>
        <button
          className={`sizelink colorLink textLink greenBtn ${setColorQRcodeMenu.hover} ${
            mode === "QRcode" ? setColorQRcodeMenu.active : "text-green-500"
          }`}
          onClick={() => setMode("QRcode")}
        >
          QRcode
        </button>
      </div> */}

      {/* <div className="grid grid-cols-1 gap-6 my-4 mt-4">
        {mode === "Barcode" && (
          <>
            <div className="flex items-center justify-center w-full h-full bg-white">
              <BarcodeScanner scanRate={250} worker={WORKER_TYPE.BARCODE} />
            </div>
          </>
        )}
        {mode === "QRcode" && (
          <>
            <div className="flex items-center justify-center w-full h-full bg-white">
              <QRcodeScanner scanRate={250} worker={WORKER_TYPE.QR} />
            </div>
          </>
        )}
      </div> */}
      <div className="grid grid-cols-1 gap-6 my-4 mt-4">
        <div className="flex items-center justify-center w-full h-full bg-white">
          <Scan scanRate={250} />
        </div>
      </div>
    </div>
  );
};

export default Home;
